import { useTranslation } from 'react-i18next';

const RecoveryConfirmation = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  return (
    <div className='container mx-auto'>
       <div className="bg-white shadow-lg rounded-lg p-6 max-w-sm text-center">
        <h2 className="text-xl font-semibold text-gray-800 mt-4">{t('password.recovery_confirmation_success')}</h2>
        <p className="text-gray-600 mt-2">{t('password.recovery_confirmation_success_message')}</p>
        <a href="/login" className="mt-4 inline-block px-4 py-2 bg-green-500 text-blue font-semibold rounded-lg shadow-md hover:bg-green-600 transition">Login</a>
    </div>
    </div>
  )
}

export default RecoveryConfirmation
